module.exports = __webpack_public_path__ + "static/media/44.c2f3020f.png";